<footer class="mastfoot mt-auto container text-center fixed-bottom">
  <div class="inner">
    <p>&copy;{{year}} - Arthur REITER </p>
  </div>
</footer>
